import { FilterItem } from '@ocean/types/dist/filter'
import { Person } from 'core/people/types'
import { SimulatorStudentLedEnrolledPerson } from 'modules/simulatorTrainings/common/types/student'

export type SchedulesRouteParams = {
  exerciseId: Guid
}

export type ScheduleEditorRouteParams = {
  scheduleId: Guid
}

export enum ScheduleStatus {
  Upcoming,
  Past,
}

export enum ShowType {
  Own,
  All,
}

export type SchedulesTagFilterItems = {
  status: FilterItem
  showType: FilterItem
}

export type SchedulesTagFilterItemNames = keyof SchedulesTagFilterItems

export type SchedulesTagFilterItem = {
  name: SchedulesTagFilterItemNames
  value: FilterItem['value']
}

export type AddSimulatorExerciseScheduleModel = {
  exerciseId: Guid
  startDate: DateTime
  endDate: DateTime
  maximumNumberOfAttempts: number
  userIds: string[]
}

export type UpdateSimulatorExerciseScheduleModel = {
  scheduleId: Guid
  startDate: DateTime
  endDate: DateTime
  maximumNumberOfAttempts: number
  userIds: string[]
}

export type SimulatorExerciseSchedule = {
  scheduleId: Guid
  trainingId: Guid
  startDate: DateTime
  endDate: DateTime
  scheduledBy: string
  enrollments: number
}

export type SchedulesListResponse = SimulatorExerciseSchedule[]

export type ScheduleCreatorData = {
  startDate?: Date
  endDate?: Date
  maximumNumberOfAttempts?: number
  addedStudents: Record<string, Person>
}

export type ScheduleEditorData = {
  startDate?: Date
  endDate?: Date
  maximumNumberOfAttempts?: number
  addedStudents: Record<string, SimulatorStudentLedEnrolledPerson>
}

export type CreateSimulatorExerciseScheduleResponse = {
  scheduleId: Guid
}
